module.exports = __webpack_public_path__ + "static/level2-278a3933dde1c135e2c676d001788ed1.png";